import { FC } from 'react';

import logoImg from 'static/assets/img/alle-mod-en-logo.png';

export const Logo: FC = () => {
  return (
    <div className="mb-8 flex flex-row justify-center">
      <img className="w-52 h-auto" src={logoImg} alt="Alle mod 1 Logo" />
    </div>
  );
};
